import type { RoleVariant } from "@/hooks/use-role-variant";

// ADV-799: per-role section titles for the Today page. Data scope itself
// differs by role via CASL at the API layer (see /finance/commissions/summary,
// /core/follow-ups, /ops/jobs). This table only swaps user-visible strings.

interface TodaySectionCopy {
  jobs: string;
  followUps: string;
  activity: string;
  commission: string;
}

export const TODAY_SECTION_COPY: Record<RoleVariant, TodaySectionCopy> = {
  rep: {
    jobs: "Today's jobs",
    followUps: "Follow-ups needed",
    activity: "Recent activity",
    commission: "Commission snapshot",
  },
  manager: {
    jobs: "Team jobs today",
    followUps: "Team follow-ups",
    activity: "Team activity",
    commission: "Team commission snapshot",
  },
  ops_admin: {
    jobs: "Account jobs today",
    followUps: "Account follow-ups",
    activity: "Account activity",
    commission: "Account commission snapshot",
  },
};
